// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'FrederickSimms', 'FrederickSimms Fallback', Objektiv, sans-serif"},"className":"__className_ee8046","variable":"__variable_ee8046"};